export { ModalColor, ModalSize } from './modal.component';
export { ModalModule } from './modal.module';
export { ModalResult } from './modal.service';
